import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "परिचय ", "id": "about-diploma" },
    { "name": "पाठ्यक्रम का उद्देश्य", "id": "course-objectives" },
    { "name": "पाठ्यक्रम प्रवेश अर्हता", "id": "eligibility" },
    { "name": "पाठ्यक्रम", "id": "curriculum" },
    { "name": "समय सारिणी", "id": "timetable" },
    { "name": "सुविधाएँ", "id": "facilities" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <h4 className="mb-4 fw-bold text-primary">परिचय</h4>
            <p>संस्कृत भाषा भारतीय मनीषा एवं संस्कृति की अनुपम निधि है। संस्कृत का स्वरूप बहुत विशाल एवं व्यापक है। असंख्य भारतीय अपने भारतीय स्वरूप की रक्षा तथा दृढ़ता के लिए संस्कृत पढ़ना चाहते हैं। उन्हें सरलतम प्रक्रिया से संस्कृत भाषा एवं उसमें सन्निहित ज्ञान-विज्ञान का परिज्ञान कराना है। इस महान् उद्देश्य की सङ्कल्पना के साथ समाज के विविध क्षेत्र के संस्कृत जिज्ञासुओं को संस्कृताध्ययन की सुविधा उपलब्ध कराने के लिए विश्वविद्यालय द्वारा संस्कृत भाषा दक्षता डिप्लोमा पाठ्यक्रम का आरम्भ किया गया है।</p>
            <p>संस्कृत भाषा में दक्षता का अर्थ है, शुद्ध उच्चारण, व्याकरण और लेखन के साथ संस्कृत भाषा में प्रभावी ढंग से संवाद करने और अपनी बात रखने की क्षमता। इसमें भाषा के नियमों और संरचनाओं को समझना और उन्हें सही ढंग से उपयोग करना शामिल है। संस्कृत भाषा दक्षता प्राप्त करने के लिए, अभ्यास, नियमित अध्ययन और संस्कृत भाषा के साथ बातचीत करना आवश्यक है। आप संस्कृत के विभिन्न शिक्षण संसाधनों का उपयोग करके भी अपनी भाषा दक्षता को बढ़ा सकते हैं।</p>
            <p>संस्कृत भाषा दक्षता का डिप्लोमा, संस्कृत भाषा में कुशलता प्राप्त करने के लिए एक विशेष कोर्स है। यह डिप्लोमा प्रोग्राम संस्कृत भाषा और साहित्य के ज्ञान को व्यापक रूप से विकसित करने के लिए डिज़ाइन किया गया है, जिससे शिक्षार्थी भारतीय भाषाओं और साहित्य की गहरी समझ प्राप्त कर सकते हैं।</p>
            <p>इस विश्वविद्यालय में संस्कृत भाषा दक्षता डिप्लोमा पाठ्यक्रम (एकवर्षीय) चलाया जा रहा है।</p>
        </>
    ),
    "course-objectives": (
        <>
            <h4 className="mb-4 fw-bold text-primary">पाठ्यक्रम का उद्देश्य</h4>
            <ul className="list-unstyled">
                <li className="mb-2">• संस्कृत भाषा और साहित्य में दक्षता प्राप्त करना।</li>
                <li className="mb-2">• संस्कृत भाषा सीखने से भारतीय संस्कृति और इतिहास की समझ विकसित करना।</li>
                <li className="mb-2">• संस्कृत भाषा में लिखे गए वेद, पुराण, रामायण, महाभारत, उपनिषद जैसे ग्रंथों का अध्ययन करने की क्षमता उत्पन्न करना।</li>
                <li className="mb-2">• संस्कृत भाषा सीखने से गणित, विज्ञान और अन्य भाषाओं को सीखना।</li>
                <li className="mb-2">• संस्कृत भाषा एक विचार, संस्कृति और संस्कार है, जिसमें विश्व का कल्याण और शांति की भावना है।</li>
            </ul>
        </>
    ),
    "eligibility": (
        <>
            <h4 className="mb-4 fw-bold text-primary">पाठ्यक्रम प्रवेश अर्हता</h4>
            <ul className="list-unstyled">
                <li className="mb-2">• संस्कृत भाषा दक्षता डिप्लोमा पाठ्यक्रम एक वर्षीय अर्थात् द्विसत्रीय समयावधि का हैं। इस पाठ्यक्रम में प्रवेश वर्ष में जून-जुलाई मास में होता है।</li>
                <li className="mb-2">• संस्कृत भाषा दक्षता डिप्लोमा पाठ्यक्रम में प्रवेश हेतु कला, वाणिज्य या विज्ञान विषय में सीनियर सैकेण्डरी सर्टिफिकेट 10+2 या मान्यता प्राप्त बोर्ड से इण्टरमीडिएट या तत्समकक्ष परीक्षा उतीर्ण होना आवश्यक है।</li>
            </ul>
        </>
    ),
    "curriculum": (
        <>
            <h4 className="mb-4 fw-bold text-primary">पाठ्यक्रम</h4>
            <h5 className="mb-3">संस्कृत भाषा दक्षता डिप्लोमा पाठ्यक्रम प्रारूप</h5>

            <h6 className="mb-3 text-success">प्रथमसत्रम्</h6>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th>विषयकूटाङ्कः</th>
                            <th>प्रश्नपत्रस्य नाम</th>
                            <th>पूर्णाङ्काः</th>
                            <th>अवधिः</th>
                            <th>श्रेयोऽङ्काः</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>AV-1.1</td>
                            <td>संस्कृतशिक्षणम् (प्रथमभागः)</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-1.2</td>
                            <td>गीताशिक्षणम् (प्रथमभागः)</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-1.3</td>
                            <td>संस्कृतकथापरिचयः (प्रथमभागः)</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-1.4</td>
                            <td>संस्कृतकथापरिचयः (द्वितीयभागः)</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h6 className="mb-3 text-info">द्वितीयसत्रम्</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th>विषयकूटाङ्कः</th>
                            <th>प्रश्नपत्रस्य नाम</th>
                            <th>पूर्णाङ्काः</th>
                            <th>अवधिः</th>
                            <th>श्रेयोऽङ्काः</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>AV-1.2</td>
                            <td>संस्कृतशिक्षणम् (द्वितीयभागः)</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-2.2</td>
                            <td>गीताशिक्षणम् (द्वितीयभागः)</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-2.3</td>
                            <td>संस्कृतवाक्यसंरचना</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-2.4</td>
                            <td>प्रायोगिकम्</td>
                            <td>100</td>
                            <td>60 होराः</td>
                            <td>04</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    ),
    "timetable": (
        <>
            <h4 className="mb-4 fw-bold text-primary">समय सारिणी</h4>
            <ul className="list-unstyled">
                <li className="mb-2">• प्रत्येक सत्र के प्रारम्भ में पाठ्यक्रम के अनुसार समय सारिणी बनाई जाती है।</li>
            </ul>
        </>
    ),
    "facilities": (
        <>
            <h4 className="mb-4 fw-bold text-primary">सुविधाएँ</h4>
            <ul className="list-unstyled">
                <li className="mb-2">• छात्रों को संस्कृत भाषा का प्रायोगिक एवं व्यावहारिक ज्ञान प्रदान करना।</li>
                <li className="mb-2">• संस्कृत भाषा की वैज्ञानिक परम्परा का ज्ञान प्रदान।</li>
                <li className="mb-2">• प्रतियोगी परीक्षाओं हेतु मार्गदर्शन।</li>
                <li className="mb-2">• संस्कृत साहित्य का ज्ञान प्रदान करना।</li>
            </ul>
        </>
    ),
    "achievements": (
        <>
            <h4 className="mb-4 fw-bold text-primary">उपलब्धियां</h4>
            <ul className="list-unstyled">
                <li className="mb-2">• विश्वविद्यालय में नूतन पाठ्यक्रम होने के कारण अभी तक कोई उपलब्धि नहीं है।</li>
            </ul>
        </>
    ),
    "contact": (
        <>
            <h4 className="mb-4 fw-bold text-primary">सम्पर्क</h4>

            <h5 className="mb-3 text-success">विभागीय शैक्षणिक सदस्य</h5>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.सं.</th>
                            <th>नाम</th>
                            <th>पद</th>
                            <th>सम्पर्क सूत्र</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>डॉ. चन्द्र कान्त</td>
                            <td>डिप्लोमा समन्वयक सहायक आचार्य (अनुबन्ध)</td>
                            <td>
                                <a href="tel:7018781438" className="text-decoration-none">
                                    7018781438
                                </a>
                            </td>
                            <td>
                                <a href="mailto:drcks.mvsu@gmail.com" className="text-decoration-none">
                                    drcks.mvsu@gmail.com
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h5 className="mb-3 text-info">विभागीय गैर-शैक्षणिक सदस्य</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.सं.</th>
                            <th>नाम</th>
                            <th>पद</th>
                            <th>सम्पर्क सूत्र</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>श्री सीता राम</td>
                            <td>लिपिक</td>
                            <td>
                                <a href="tel:8950765174" className="text-decoration-none">
                                    8950765174
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
};

export default function SanskritBhashaDakshataDiploma() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]);
    const [activeId, setActiveId] = useState(departments.id);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setCurrentContent(contentData[deptId]);
        setActiveId(deptId);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* मोबाइल के लिए टॉगल बटन */}
            <button
                className="btn d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{ backgroundColor: '#77236b', color: 'white', border: 'none' }}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}
            >
                <div
                    className="text-center fw-bold mb-3 text-white p-3 rounded"
                    style={{ backgroundColor: '#77236b', userSelect: 'none' }}
                >
                    <p className="mb-0" style={{ fontSize: '1.15rem' }}>संस्कृत भाषा दक्षता डिप्लोमा</p>
                </div>

                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className="mb-1 p-2 rounded shadow-sm small transition-all cursor-pointer"
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                backgroundColor: activeId === dept.id ? '#77236b' : '#ffffff',
                                color: activeId === dept.id ? '#ffffff' : '#212529',
                                userSelect: 'none'
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* मुख्य कंटेंट */}
            <main
                className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >
                <div className="container-fluid">{currentContent}</div>
            </main>

            {/* Custom CSS for hover and transition */}
            <style>{`
                .p-2:hover {
                    background-color: #e8d5e8 !important;
                    color: #77236b !important;
                }
                .table-hover tbody tr:hover {
                    background-color: rgba(119, 35, 107, 0.1);
                }
                .transition-all {
                    transition: all 0.3s ease;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
}
